import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export const firstbasePoImportHeaderSchema = yup.object().shape({
  action: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  supplierName: yup.string().nullable().optional(),
  supplierNumber: yup.string().nullable().optional(),
  chartOfAccountName: yup.string().nullable().optional(),
  shipToStreet1: yup.string().nullable().optional(),
  shipToStreet2: yup.string().nullable().optional(),
  shipToCity: yup.string().nullable().optional(),
  shipToState: yup.string().nullable().optional(),
  shipToPostalCode: yup.string().nullable().optional(),
  shipToCountryCode: yup.string().nullable().optional(),
  shipToEmail: yup.string().nullable().optional(),
  transmissionMethodOverride: yup.string().nullable().optional(),
  currencyCode: yup.string().nullable().optional(),
})

export const firstbasePoImportLineSchema = yup.object().shape({
  lineNumber: yup.string().nullable().optional(),
  nonCatalogItemDescription: yup.string().nullable().optional(),
  quantity: yup.string().nullable().optional(),
  price: yup.string().nullable().optional(),
  uomCode: yup.string().nullable().optional(),
  accountName: yup.string().nullable().optional(),
  accountCode: yup.string().nullable().optional(),
  accountSegment1: yup.string().nullable().optional(),
  accountSegment2: yup.string().nullable().optional(),
  accountSegment3: yup.string().nullable().optional(),
})

export const firstbasePoImportFileDataSchema = yup.object().shape({
  purchaseOrders: yup
    .array()
    .of(
      yup.object().shape({
        header: firstbasePoImportHeaderSchema.required(),
        lines: yup.array().of(firstbasePoImportLineSchema).required(),
      }),
    )
    .required(),
})

export type FirstbasePoImportHeaderData = yup.InferType<typeof firstbasePoImportHeaderSchema>

export type FirstbasePoImportLineData = yup.InferType<typeof firstbasePoImportLineSchema>

export type FirstbasePoImportFileData = yup.InferType<typeof firstbasePoImportFileDataSchema>

type RequiredFileData = MakeRequiredAndNullable<FirstbasePoImportFileData>

export const firstbasePoImportFileMappings: RequiredFileData = {
  purchaseOrders: [
    {
      header: {
        action: '3f8a9d2e-1c4b-4e7a-9f3d-6c2e8a4b9d1f',
        poNumber: '7e2c4a8d-9b3e-4f1a-8d2c-5a7e9b3f4d1a',
        supplierName: '9d4f2e8a-7c3b-4d1e-9a8f-3b7c5d2e8f4a',
        supplierNumber: '2e8d4a9f-3b7c-4e1a-8d9f-7c3b5e2a8d4f',
        chartOfAccountName: '8f3d2a7e-9b4c-4e1a-8d2f-5c7e9b3a4d2f',
        shipToStreet1: '1ecc5856-66e2-4bf5-a435-4328fa11f3df',
        shipToStreet2: 'a29ef6aa-0bd1-4c7c-b29e-29c7352ac21b',
        shipToCity: 'ed456df6-6b59-4298-bca7-8f65003746ac',
        shipToState: '88c4d766-0416-4730-8d0f-75b186ab3755',
        shipToPostalCode: '9eb0d440-88a9-4567-b715-65e0ee59f9b9',
        shipToCountryCode: 'eddc26b5-ee9b-4d32-b9cf-3498cea5643d',
        shipToEmail: '7c3d9a2e-4b8f-4e1a-9d2c-5a7e8b3f4d2a',
        transmissionMethodOverride: '9f2e8d4a-7c3b-4e1a-8d9f-3b7c5a2e8d4f',
        currencyCode: '2d8f4a9e-3b7c-4e1a-8d9f-7c5e3b2a8d4f',
      },
      lines: [
        {
          lineNumber: '5a9e2d8f-4c7b-4e1a-9d3f-7c2e8b5a4d9f',
          nonCatalogItemDescription: '8d4f9a2e-7c3b-4e1a-9d2f-5a7c3b8e4d9f',
          quantity: '3f9d2a8e-7c4b-4e1a-8d2f-5c7e9a3b4d2f',
          price: '7e2a8d4f-9c3b-4e1a-8d2f-5a7c3b9e4d8f',
          uomCode: '9a3e8d2f-7c4b-4e1a-8d9f-2c7e5a3b4d9f',
          accountName: '2f8d4a9e-7c3b-4e1a-8d9f-5c7e3a2b4d8f',
          accountCode: '8e9a2d4f-7c3b-4e1a-9d2f-5a7c8e3b4d9f',
          accountSegment1: '9d2f8a4e-7c3b-4e1a-8d9f-2c7e5a8b4d3f',
          accountSegment2: '4a8e9d2f-7c3b-4e1a-8d2f-5c7e9a3b4d8f',
          accountSegment3: '7c2e8d4a-9f3b-4e1a-8d9f-5a7c2e3b4d8f',
        },
      ],
    },
  ],
}
